import Hero from './hero'

export default function ReferralCode() {
  return (
    <>
      <Hero />
      <C.CommonIntro />
    </>
  )
}
